export const SESSION_MY_HOME_HOMEOWNER_TRAP_KEY = 'my_home_homeowner_trap_key';
